import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="relative bg-background-100 pt-20 pb-10 overflow-hidden">
      <div className="absolute -left-8 top-16 w-28 h-20 bg-foreground-900 rounded-xl -rotate-12 opacity-5 hidden lg:block"></div>
      <div className="absolute -right-8 top-24 w-28 h-20 bg-foreground-900 rounded-xl -rotate-12 opacity-5 hidden lg:block"></div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-white rounded-3xl p-8 md:p-12 mb-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-4">
              <Link to="/" className="flex items-center gap-3 mb-5 group">
                <div className="w-9 h-9 rounded-xl bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                  <i className="ri-search-line text-white text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-foreground-900 tracking-tight whitespace-nowrap">
                  Kakobuy Finds
                </span>
              </Link>
              <p className="text-[14px] text-foreground-500 leading-relaxed font-body max-w-[280px]">
                Największa polska baza Kakobuy Spreadsheet — niezależne porównania, przewodniki zakupowe i codziennie aktualizowane listy produktów.
              </p>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-[11px] font-bold text-foreground-400 uppercase tracking-[0.1em] mb-5 whitespace-nowrap">
                KATEGORIE
              </h4>
              <div className="grid grid-cols-2 gap-y-2.5">
                {categories.map((cat) => (
                  <a
                    key={cat.nameEn}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-[14px] text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap font-body"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-[11px] font-bold text-foreground-400 uppercase tracking-[0.1em] mb-5 whitespace-nowrap">
                SEO & PRZEWODNIKI
              </h4>
              <div className="flex flex-col gap-y-2.5">
                <Link to="/" className="text-[14px] text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap font-body">
                  Strona Główna
                </Link>
                <Link to="/co-to-jest-kakobuy-sheet" className="text-[14px] text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap font-body">
                  Co to jest Kakobuy Sheet?
                </Link>
              </div>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-[11px] font-bold text-foreground-400 uppercase tracking-[0.1em] mb-5 whitespace-nowrap">
                INFORMACJE
              </h4>
              <div className="flex flex-col gap-y-2.5">
                <a href="#" className="text-[14px] text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap font-body">
                  O nas
                </a>
                <a href="#" className="text-[14px] text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap font-body">
                  Kontakt
                </a>
                <a href="#" className="text-[14px] text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap font-body">
                  Polityka prywatności
                </a>
                <a href="#" className="text-[14px] text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap font-body">
                  Disclaimer
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-200/40 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-4 text-[13px] text-foreground-400 font-body">
            <span className="whitespace-nowrap">© 2026 Kakobuy Finds. Wszelkie prawa zastrzeżone.</span>
            <span className="hidden sm:block text-foreground-300">|</span>
            <a href="#" className="hover:text-primary-600 transition-colors whitespace-nowrap">Regulamin</a>
            <span className="text-foreground-300">|</span>
            <a href="#" className="hover:text-primary-600 transition-colors whitespace-nowrap">Polityka prywatności</a>
            <span className="text-foreground-300">|</span>
            <a href="#" className="hover:text-primary-600 transition-colors whitespace-nowrap">Cookies</a>
          </div>

          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 rounded-full bg-foreground-100 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer">
              <i className="ri-instagram-line"></i>
            </a>
            <a href="#" className="w-9 h-9 rounded-full bg-foreground-100 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer">
              <i className="ri-tiktok-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}